(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (theme.config.mqlSmall) {
          // Mobile: header is fixed at bottom, always visible — just add sticky class
          if (scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('shopify-section-header-sticky');
            document.body.classList.add('shopify-body-section-header-sticky');
          } else if (scrollTop <= this.headerBounds.top) {
            requestAnimationFrame(this.reset.bind(this));
          }
        }
        else if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.reveal.bind(this));
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  /*
    Swap header button text to CLOSE when drawers are open on mobile.

    The cart label is read back from data-cart-label, never from the live
    textContent. Adding to bag re-renders #cart-icon-bubble and opens the drawer
    in the SAME task, so both mutations are delivered in one microtask
    checkpoint and this body-class observer — created first, so it runs first —
    used to write CLOSE over the new count before anything had cached it. The
    stale count was then restored when the drawer closed, which is why the bag
    read (0) after an add but updated correctly after a remove (no drawer open,
    so no competing mutation).
  */
  (function() {
    var menuTexts = document.querySelectorAll('.header__icon--menu .header__icon-text');
    var cartBubble = document.getElementById('cart-icon-bubble');
    var menuOriginals = [];

    menuTexts.forEach(function(el) { menuOriginals.push(el.textContent); });

    function isMobile() {
      // Matches where the drawer is actually used: header-drawer is hidden from
      // 1100px up, so anything below that opens the drawer and the button should
      // read CLOSE.
      return !window.matchMedia('(min-width: 1100px)').matches;
    }

    function bodyHas(a, b) {
      return document.body.classList.contains(a) || document.body.classList.contains(b);
    }

    function syncCart() {
      if (!cartBubble) return;
      var ct = cartBubble.querySelector('.header__icon-text');
      if (!ct) return;
      var label = ct.getAttribute('data-cart-label') || ct.textContent;
      var wanted = (isMobile() && bodyHas('mini-cart--open', 'mini-cart--opening')) ? 'CLOSE' : label;
      // Guarded so our own write doesn't loop through the observer below.
      if (ct.textContent !== wanted) ct.textContent = wanted;
    }

    function syncMenu() {
      if (!isMobile()) return;
      var menuOpen = bodyHas('menu-mobile--open', 'menu-mobile--opening');
      menuTexts.forEach(function(el, i) {
        el.textContent = menuOpen ? 'CLOSE' : (menuOriginals[i] || el.textContent);
      });
    }

    new MutationObserver(function() {
      syncMenu();
      syncCart();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Re-assert the label after the cart section re-renders (add, remove,
    // cart:refresh), whichever order the mutations arrive in.
    if (cartBubble) {
      new MutationObserver(syncCart)
        .observe(cartBubble, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-cart-label'] });
    }
  })();

  /* Prevent Shopify account widget from locking scroll on html */
  (function() {
    new MutationObserver(function() {
      var html = document.documentElement;
      if (html.style.overflow === 'hidden') {
        html.style.overflow = '';
      }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
  })();

  /* Header wishlist count (Swym). Shows "(n)" only when the list has items.
     Updates every count element (desktop header + mobile drawer). */
  (function() {
    var countEls = document.querySelectorAll('[data-swym-wishlist-count]');
    if (!countEls.length) return;

    function render(n) {
      countEls.forEach(function(countEl) {
        if (n && n > 0) {
          countEl.textContent = '(' + n + ')';
          countEl.hidden = false;
        } else {
          countEl.textContent = '';
          countEl.hidden = true;
        }
      });
    }

    function fetchCount() {
      // Swym exposes the wishlist via _swat once its SDK has loaded.
      if (!window._swat || typeof window._swat.fetch !== 'function') return false;
      window._swat.fetch(function(items) {
        render(Array.isArray(items) ? items.length : 0);
      }, function() {
        render(0);
      });
      return true;
    }

    // Swym fires this event when its SDK is ready.
    document.addEventListener('swym-loaded', fetchCount);

    // Re-check after the user adds/removes an item (Swym dispatches these).
    ['swym:added-to-wishlist', 'swym:removed-from-wishlist', 'swym:collections-loaded'].forEach(function(evt) {
      document.addEventListener(evt, fetchCount);
    });

    // Fallback: poll briefly in case the SDK loaded before this script ran
    // (or the event was missed). Stops once it succeeds or after ~10s.
    var tries = 0;
    var poll = setInterval(function() {
      tries += 1;
      if (fetchCount() || tries > 20) clearInterval(poll);
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();
})();
